export default function Spacer({ twUnit, amount }) {
  const classname = `${twUnit}-${amount}`;
  return <div className={classname}></div>;
}
